import { render } from "./PlanComparator.vue?vue&type=template&id=69420560&scoped=true"
import script from "./PlanComparator.vue?vue&type=script&lang=ts"
export * from "./PlanComparator.vue?vue&type=script&lang=ts"

import "./PlanComparator.vue?vue&type=style&index=0&id=69420560&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69420560"

export default script